'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  display: _propTypes2.default.oneOf(['default', 'caption', 'body', 'bodyStrong', 'subheading', 'title', 'headline', 'display1', 'display2', 'display3', 'display4'])
};

var defaultProps = {
  display: 'default'
};

var display = function display(_ref) {
  var display = _ref.display,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.text[display],
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      color = _theme$reactackle$com.color,
      textTransform = _theme$reactackle$com.textTransform,
      fontWeight = _theme$reactackle$com.fontWeight,
      letterSpacing = _theme$reactackle$com.letterSpacing,
      fontFamily = _theme$reactackle$com.fontFamily,
      marginTop = _theme$reactackle$com.marginTop,
      marginBottom = _theme$reactackle$com.marginBottom,
      similarItemsSpacing = _theme$reactackle$com.similarItemsSpacing;


  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';color:', ';text-transform:', ';font-weight:', ';letter-spacing:', ';font-family:', ';margin-top:', ';margin-bottom:', ';& + &{margin-top:', ';}'], (0, _reactackleCore.getValueString)(fontSize), lineHeight, color, textTransform, fontWeight, (0, _reactackleCore.getValueString)(letterSpacing), fontFamily, (0, _reactackleCore.getValueString)(marginTop), (0, _reactackleCore.getValueString)(marginBottom), (0, _reactackleCore.getValueString)(similarItemsSpacing));
};

var TextStyled = exports.TextStyled = _styledComponents2.default.span.withConfig({
  displayName: 'TextStyled'
})(['display:inline-block;', ''], display);

TextStyled.propTypes = propTypes;
TextStyled.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text/dist/styles/TextStyled.js
// module id = 860
// module chunks = 0